import api from "../../config/api";
import axios from "axios";


export default {
  //  请求食谱分类
  recipeCategoryListAction({state, commit}) {
    return new Promise((resolve, reject) => {
      try {
        const params = {
          brandOwnerCode: state.userInfo.brandOwnerCode,
          onPage: false,
        };
        axios.get(api.recipeCategory.list, { params }).then(res => {
          if (res.data.status !== 200) {
            reject(res.data);
            return;
          }
          const list = res.data.data["recipeCategoryList"];
          commit("CHANGE_RECIPE_CATEGORY_LIST", list)
          resolve(list);
        })
      } catch (e) {
        reject(e);
      }
    })
  },

  // 标签列表
  tagListAction({state, commit}) {
    return new Promise((resolve, reject) => {
      try {
        const params = {
          brandOwnerCode: state.userInfo.brandOwnerCode,
          onPage: false,
        }
        axios.get(api.recipeTag.list, { params }
        ).then(res => {
          if (res.data.status !== 200) {
            reject(res.data);
            return;
          }
          const list = res.data.data["recipeTags"];
          commit("CHANGE_TAG_LIST", list)
          resolve(list);
        })
      } catch (e) {
        reject(e);
      }
    })
  },

  // 型号列表
  productListAction({state, commit}) {
    return new Promise((resolve, reject) => {
      try {
        const params = {
          brandOwnerCode: state.userInfo.brandOwnerCode,
          onPage: false,
        }
        axios.get(api.common.loadBrandOwnerProduct, { params }
        ).then(res => {
          if (res.data.status !== 200) {
            reject(res.data);
            return;
          }
          const list = res.data.data["brandOwnerProductList"];
          commit("CHANGE_PRODUCT_LIST", list)
          resolve(list);
        })
      } catch (e) {
        reject(e);
      }
    })
  },

  // 工作模式列表
  workModeListAction({commit}) {
    return new Promise((resolve, reject) => {
      try {
        const params = {
          dictTypeFlag: "WORK_MODE"
        }
        axios.get(api.common.loadDict, { params }
        ).then(res => {
          if (res.data.status !== 200) {
            reject(res.data);
            return;
          }
          const list = res.data.data["dictList"];
          commit("WORK_MODE_LIST", list)
          resolve(list);
        })
      } catch (e) {
        reject(e);
      }
    })
  }


}
